if (!customElements.get('testimonials-slider')) {
  customElements.define(
    'testimonials-slider',
    class TestimonialsSlider extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.sectionId = this.getAttribute('data-section-id');
      }

      connectedCallback() {
        if (window.Shopify?.designMode) {
          import('https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs')
            .then(() => requestAnimationFrame(() => requestAnimationFrame(() => this.init())));
          return;
        }

        const observer = new IntersectionObserver(
          async (entries) => {
            if (entries[0].isIntersecting) {
              observer.disconnect();
              await this.init();
            }
          },
          { rootMargin: '200px' }
        );
        observer.observe(this);
      }

      async init() {
        this.swiperAutoplay = this.getAttribute('data-swiper-autoplay') !== 'false';
        this.autoplayDelay = Number(this.getAttribute('data-autoplay-delay')) || 3000;

        const module = await import('https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs');
        const Swiper = module.default;
        const { Pagination, Navigation } = module;

        if (!this.swiperEls.swiperContainer) return;

        this.swiperOptions = {
          modules: [Pagination, Navigation],
          direction: 'horizontal',
          slidesPerView: 1,
          loop: true,
          autoplay: this.swiperAutoplay ? {
            delay: this.autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          } : false,
          pagination: this.swiperEls.pagination ? {
            el: this.swiperEls.pagination,
            clickable: true,
          } : false,
          navigation: (this.swiperEls.prev && this.swiperEls.next) ? {
            nextEl: this.swiperEls.next,
            prevEl: this.swiperEls.prev,
          } : false,
          observer: true,
          observeParents: true,
          breakpoints: {
            769: {
              slidesPerView: 2
            },
            1025: {
              slidesPerView: 3
            },
            1440: {
              slidesPerView: 4
            },
          },
        }

        this.swiper = new Swiper(this.swiperEls.swiperContainer, this.swiperOptions);

        new MutationObserver(() => this.swiper.update())
          .observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.swiper?.destroy();
      }

      get swiperEls() {
        return {
          swiperContainer: this.querySelector(`[id^="Swiper-${this.sectionId}"]`),
          pagination: this.querySelector(`[id^="Swiper-pagination-${this.sectionId}"]`),
          prev: this.querySelector(`[id^="Swiper-prev-${this.sectionId}"]`),
          next: this.querySelector(`[id^="Swiper-next-${this.sectionId}"]`)
        }
      }
    }
  );
}